import styled from 'styled-components';

export const Container = styled.div`
	max-width: 640px;
	margin: 0 auto;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

// Creates responsive div around iframe for
// any size container.
export const VideoWrapper = styled.div`
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
	width: 100%;
`;

export const StyledIframe = styled.iframe`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;
